import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
  Stack,
  TextField
} from "@fluentui/react";
import { Icon } from "@fluentui/react/lib/Icon";
import { useState } from "react";

import { FilterComponentProps, FilterTerms } from "./interfaces";
import { normalizeTextArrayFilterValue } from "./normalizeTextArrayFilterValue";

export function TextArrayFilter({
  setSelectedTerms,
  filterConfigs,
  selectedTerms,
  sendArrayAsCommaSeparatedString
}: FilterComponentProps): JSX.Element {
  const [textAreaValue, setTextAreaValue] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const filterQuery = filterConfigs.filterQuery as string;
  const selectedValues = normalizeTextArrayFilterValue(
    selectedTerms[filterQuery],
    filterConfigs.maskFormatter
  );
  const hasSelectedValues = selectedValues.length > 0;
  const buttonText = hasSelectedValues
    ? `${selectedValues.length} ${filterConfigs.successDescription}`
    : filterConfigs.placeholder;

  function openModal() {
    setTextAreaValue(selectedValues.join("\n"));
    setModalIsOpen(true);
  }

  function handleFilterButton() {
    const values = normalizeTextArrayFilterValue(
      textAreaValue,
      filterConfigs.maskFormatter
    );

    setSelectedTerms((prevState: FilterTerms) => {
      const nextState = { ...prevState };

      if (values.length) {
        nextState[filterQuery] = sendArrayAsCommaSeparatedString
          ? values.join(",")
          : values;
      } else {
        delete nextState[filterQuery];
      }

      return nextState;
    });

    setModalIsOpen(false);
  }

  return (
    <Stack>
      <Stack>
        <p style={{ fontWeight: 600, marginBottom: 0, padding: "5px 0" }}>
          {filterConfigs.label}
        </p>
        <DefaultButton
          disabled={Boolean(filterConfigs.disabled)}
          onClick={openModal}
          label={filterConfigs.label}
          title={filterConfigs.boxTitle}
          ariaLabel={filterConfigs.label}
          style={{
            maxHeight: "30px",
            border: "1px solid rgb(96, 94, 92)"
          }}
        >
          <Icon
            iconName="OpenInNewWindow"
            style={{ fontSize: 16, marginRight: 6 }}
          />

          {buttonText}
        </DefaultButton>
      </Stack>

      <Dialog
        hidden={!modalIsOpen}
        onDismiss={() => setModalIsOpen(false)}
        dialogContentProps={{
          type: DialogType.normal,
          title: filterConfigs.dialogTitle,
          subText: filterConfigs.dialogSubText,
          isMultiline: true
        }}
        maxWidth={"400px"}
      >
        <TextField
          ariaLabel={filterConfigs.dialogSubText}
          placeholder={filterConfigs.placeholder}
          multiline
          onChange={(_, newValue) => setTextAreaValue(newValue || "")}
          value={textAreaValue}
          rows={10}
        />

        <DialogFooter>
          <DefaultButton
            onClick={() => setModalIsOpen(false)}
            text="Cancelar"
          />
          <PrimaryButton onClick={handleFilterButton} text="Filtrar" />
        </DialogFooter>
      </Dialog>
    </Stack>
  );
}
